import React from "react";
import { Col } from "react-bootstrap";
import styled from "styled-components";
import PropTypes from "prop-types";

const circleHeight = 30;

const Step = (props) => {
  const { steps, currentStep } = props;
  let indexStep = 0;
  return (
    <Col>
      <Container>
        {Array(steps.length * 2)
          .fill(1)
          .map((item, idx) => {
            if (idx % 2 === 0) {
              return (
                <div
                  key={`step_${item}`}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <BorderDot>{currentStep === indexStep && <Dot />}</BorderDot>
                  {/* <p>{item}</p> */}
                </div>
              );
            }

            if (idx !== steps.length * 2 - 1) {
              indexStep += 1;
              // indexStep += 1;
              return <Line key={`step_${item}`} />;
            }
            return null;
          })}
      </Container>
    </Col>
  );
};

Step.propTypes = {
  steps: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default Step;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 1;
`;

const Dot = styled.div`
  position: absolute;
  width: ${circleHeight / 2}px;
  height: ${circleHeight / 2}px;
  background: red;
  left: 24%;
  border-radius: 30px;
  top: 24%;
`;

const BorderDot = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  border: 1px solid red;
  border-radius: 30px;
`;

const Line = styled.div`
  height: ${circleHeight / 2}px;
  width: 100px;
  border-bottom: 1px solid black;
`;
